export default __webpack_public_path__ + "static/media/Photo 4 - BR - Protection et végétalisation.0f1ab5bc.png";